/**
 * 功能: 厂牌信息新增、修改数据的弹框组件
 */
<template lang="pug">
  el-dialog(title="厂牌" :visible.sync="isShowTeam" :close-on-click-modal="false")
    el-form.demo-addTeam(:model="teamInfo" :rules="rules" ref="teamRef" label-width="80px" )
      el-row
        el-col(:span="22")
            el-form-item.fl(label="上传头像" prop="avatar" style="float:left")
              el-upload.avatar-uploader( :action="GLOBAL.uploadHost+ 'team/upload'" :headers="headers" :show-file-list="false" :on-success="success" :before-upload="beforeAvatarUpload" accept="image/jpeg,image/png" v-loading="loading")
                img( v-if="imageUrl" :src="GLOBAL.OSS+imageUrl" class="avatar" )
                i( v-else class="el-icon-plus avatar-uploader-icon")
      el-row
        el-col(:span="11")
          el-form-item.fl(label="厂牌名称" prop="name")
            el-input(v-model="teamInfo.name" placeholder="请输入名称(不可重复)" :size="GLOBAL.SIZE_OF_INPUTBOX" @blur="checkRepeat()")
        el-col(:span="13")
          el-form-item.fl(label="对外电话" prop="phone")
            el-input(v-model="teamInfo.phone" :size="GLOBAL.SIZE_OF_INPUTBOX")
      el-row
        el-col(:span="11")
          el-form-item.fl(label="添加成员")
            el-autocomplete(popper-class="my-autocomplete" v-model="inputValue" :fetch-suggestions="memberSearch" placeholder="请输入内容" @select="addTag")
              template(slot-scope="{ item }")
                div(class="name") {{ '姓名：'+item.name }}
                span(class="description") {{'描述：'+ item.description }}
            el-tag(:key="tag._id" v-for="tag in memberTags" closable :disable-transitions="false" @close="handleClose(tag)") {{tag.name}}
        el-col(:span="13")
          el-form-item.fl(label="网址" prop="url")
            el-input(v-model="teamInfo.url" :size="GLOBAL.SIZE_OF_INPUTBOX")
      el-row
        el-col(:span="22")
          el-form-item(label="描述" prop="description")
            el-input(v-model="teamInfo.description" type="textarea" :rows="8" :size="GLOBAL.SIZE_OF_INPUTBOX" placeholder="请输入内容")
      el-row
        el-col(:span="11")
          el-form-item
            el-button(type="primary" @click="addTeam" :size="GLOBAL.SIZE_OF_INPUTBOX") 保存
            el-button(@click="isShowTeamDialog" :size="GLOBAL.SIZE_OF_INPUTBOX") 取消

</template>
<script>
import passport from '@/javascripts/passport'
import Team from '@/apis/team'
export default {
  components: { },
  props: {
    teamInfo: {
      type: Object
    }
  },
  data () {
    return {
      headers: passport.headers(),
      loading: false,
      imageUrl: '',
      isShowTeam: false,
      members: [],
      inputValue: '',
      memberTags: [],
      memberIds: [],
      rules: {
        name: [
          { required: true, message: '请输入厂牌名称', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入描述信息', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.getAllMember()
  },
  methods: {
    // 添加厂牌
    addTeam () {
      this.$refs.teamRef.validate(valid => {
        if (valid) {
          this.$emit('saveTeam', this.teamInfo, () => {
            this.isShowTeamDialog()
          })
        }
      })
    },
    // 是否显示录入厂牌数据的dialog
    isShowTeamDialog () {
      this.isShowTeam = !this.isShowTeam
      if (this.isShowTeam) {
        this.$nextTick(() => {
          this.$refs.teamRef.clearValidate()
        })
      }
      this.$parent.getTeam()
      this.getAllMember()
    },
    // 验证名称是否重复   若无_id，说明是添加，查找所有防止厂牌名称重复
    checkRepeat () {
      if (!this.teamInfo._id) {
        if (this.teamInfo.name) {
          Team.findTeamName({ name: this.teamInfo.name }).then(r => {
            if (r.data.length > 0) {
              this.$message({
                type: 'warning',
                message: '该厂牌已存在，请重新输入'
              })
              this.teamInfo.name = ''
            }
          })
        }
      } else {
        // 若有 _id ，说明是修改，根据修改前后不同则验证，否则不验证
        Team.findTeamName({ _id: this.teamInfo._id }).then(r => {
          if (r.data[0].name !== this.teamInfo.name) {
            Team.findTeamName({ name: this.teamInfo.name }).then(r => {
              if (r.data.length > 0) {
                this.$message({
                  type: 'warning',
                  message: '该厂牌已存在，请重新输入'
                })
                this.teamInfo.name = ''
              }
            })
          }
        })
      }
    },
    // 上传头像图片验证
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 < 100
      this.loading = true
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
        this.loading = false
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 100KB!')
        this.loading = false
      }
      return isJPG && isLt2M
    },
    // 删除标签
    handleClose (tag) {
      // this.members.push(tag) // 将删除的内容返回到自动补全中
      this.memberTags.splice(this.memberTags.indexOf(tag), 1)
    },
    // 成功上传后执行
    success (res, file) {
      this.loading = false
      this.imageUrl = res.data
      this.teamInfo.avatar = res.data
    },
    // 搜索成员信息
    memberSearch (queryString, cb) {
      var members = this.members
      var results = queryString ? members.filter(this.createFilter(queryString)) : members
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    // 搜索过滤的条件
    createFilter (queryString) {
      return (members) => {
        return (members.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    // 获取所有成员信息
    getAllMember () {
      Team.findMember({}).then(r => {
        this.members = r.data
        // console.log('成功获取所有成员信息')
      })
    },
    addTag (item) {
      let count = 0
      for (let i = 0; i < this.memberTags.length; i++) {
        if (this.memberTags[i]._id === item._id) {
          count++
        }
      }
      if (count === 0) {
        this.memberTags.push(item) // 将添加内容放到标签中
      }
      this.teamInfo.memberIds = this.memberTags
      // this.members.splice(this.members.indexOf(item), 1)// 将添加的内容从自动补全中删除
    }

  }
}
</script>

<style scoped>
.avatar-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    line-height:0;
    overflow: hidden;
  }
  .avatar-uploader:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: auto;
    display: block;
  }
    .el-tag + .el-tag {
    margin-left: 10px;
  }

/****自动补全css */
.my-autocomplete  li {
    line-height: normal;
    padding: 7px;
  }
.my-autocomplete  li .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
.my-autocomplete  li  .description {
      font-size: 12px;
      color: #b4b4b4;
    }

.my-autocomplete  li  .highlighted .description {
      color: #ddd;
    }

</style>
